import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=dbb2c8aa&"
import script from "./rating.vue?vue&type=script&lang=ts&"
export * from "./rating.vue?vue&type=script&lang=ts&"
import style0 from "./rating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports